import React from "react";
import "./hero.css";
import { Link } from "react-router-dom";
//import Woman from "../../assets/smiling.png";
//import Background from "../../assets/run.jpg";
import JoinImg from "../../assets/mobile_join_img.webp";
const Hero = () => {
  return (
    <div id="hero">
      <>
        <div className="introContent">
          <div className="intro__Info">
            <h2 className="introHead">Golden Girls on the Move</h2>
            <span className="introText">
              Golden Girls on the Move is a non-political non-profit association
              whose mission is to nurture the active participation of women 50+
              in sports while supporting young sportswomen in Kenya.
            </span>
            <div className="buttonContainer">
              <button type="button" className="firstBtn">
                <Link to="/about">About Us <i className="fa-solid fa-arrow-right"></i></Link>
              </button>
              <button type="button" className="introBtn">
                <Link to="/register">Become a member <i className="fa-solid fa-arrow-right"></i></Link>
              </button>
            </div>
          </div>
        </div>
      </>
      <div className="join">
        <div className="joinInvitation">
          <div className="joinInfo">
            <h2 className="joinHead">New Members are Welcome!</h2>
            <p className="joinText">
              Registration is always open for new members. Join us today to improve not only your life but also the lives of many women. Our organization focuses on these aspects:
              <br />
            </p>
            <div className="iconAspectsDiv">
              <div className="iconAspect">
                <i className="fa-solid fa-heart-pulse aspectIcon"></i>
                <span className="aspectText">Physical</span>
              </div>
              <div className="iconAspect">
                <i className="fa-solid fa-brain aspectIcon"></i>
                <span className="aspectText">Mental</span>
              </div>
              <div className="iconAspect">
                <i className="fa-solid fa-users aspectIcon"></i>
                <span className="aspectText">Social</span>
              </div>
              <div className="iconAspect">
                <i className="fa-solid fa-hands-praying aspectIcon"></i>
                <span className="aspectText">Spiritual</span>
              </div>
            </div>
            <div className="joinBtnDiv">
              <button className="joinBtn">
                <a href="/register">Register Now <i className="fa-solid fa-arrow-right"></i></a>
              </button>
            </div>
          </div>
          <div className="joinImgDiv">
            <img src={JoinImg} alt="joinImg" className="joinImg"></img>
          </div>
          <button className="mob-joinBtn">
            <a href="/register">Register Now <i className="fa-solid fa-arrow-right"></i></a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
